var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('spouse-partner-login-assistance',_vm._b({},'spouse-partner-login-assistance',_vm.childComponentProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }